

  const getMotivationalMessage = (userName) => {

    const motivationalMessages = [
        `${userName}, you're doing incredible! Keep up the hard work!`,
        `Great job, ${userName}! You’re making amazing progress!`,
        `${userName}, you’re on fire today! Keep it going!`,
        `You're crushing it, ${userName}! Don’t stop now!`,
        `${userName}, nice work! Keep going!`,
        `${userName}, every day counts! Keep it up!`,
        `Amazing job, ${userName}! You're doing fantastic!`,
        `${userName}, you're unstoppable! Keep pushing forward!`,
        `${userName}, your progress is inspiring! Keep it up!`,
        `${userName}, Keep up the good work! Stay motivated!`,
        `Awesome work, ${userName}! You're doing amazing!`,
        `${userName}, you're getting closer to your goal every day!`,
        `${userName}, way to show up! Keep it going!`,
        `You're doing great, ${userName}! Stay strong!`,
        `Incredible job, ${userName}! Your hard work is paying off!`,
        `${userName}, you're making this look easy! Keep pushing!`,
        `${userName}, Phenomenal! Keep moving forward!`,
        `You're amazing, ${userName}! Let’s make today count!`,
        `${userName}, you're awesome! Keep the momentum going!`,
        `Look at you go, ${userName}! You're almost there!`,
        `Keep it up, ${userName}! You’re making great progress!`,
        `${userName}, you're doing awesome! Keep that energy up!`,
        `Fantastic job, ${userName}! Let’s finish strong!`,
        `${userName}, your dedication is paying off! Keep it up!`,
        `${userName}, you're on the right track! Keep going!`,
        `Great work, ${userName}! Every step gets you closer!`,
        `${userName}, you're pushing through! Amazing effort!`,
        `You’ve got this, ${userName}! Keep striving for greatness!`,
        `You're on the right path, ${userName}! Keep it going!`,
        `${userName}, you're making amazing strides! Keep it up!`,
      ];

    const randomIndex = Math.floor(Math.random() * motivationalMessages.length);
    return motivationalMessages[randomIndex];
  };

  export default getMotivationalMessage;